// extracted by mini-css-extract-plugin
export default {"msgM":"e16a03b474"};